import { getSHA256Hash } from '../../helpers/hash/hash';

const domainRegex = /@([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/;
export type DomainHash = string;
export type OrganizationId = string;
export type SsoOrganizationMap = [DomainHash, OrganizationId][];

let ssoOrganizationMap: SsoOrganizationMap | undefined = undefined;
if (process.env.ORY_SSO) {
  try {
    ssoOrganizationMap = JSON.parse(process.env.ORY_SSO);
  } catch (e) {
    ssoOrganizationMap = undefined;
  }
}

export function getSsoOrganizationMap(): SsoOrganizationMap | undefined {
  return ssoOrganizationMap;
}

export async function tryToGetSSOOrganizationIdFromEmailValue(
  emailValue: string,
  SSOOrganizationMap: SsoOrganizationMap | undefined
): Promise<OrganizationId | undefined> {
  if (SSOOrganizationMap && SSOOrganizationMap.length > 0 && emailValue) {
    const domainMatch = domainRegex.exec(emailValue);
    if (domainMatch?.[1]) {
      const domainHash = await getSHA256Hash(domainMatch[1]);
      return SSOOrganizationMap.find(([hash, _organizationId]) => hash === domainHash)?.[1];
    }
  }
  return undefined;
}
